<ng-container *ngIf="currentPart?.fti?.camper?.active && currentPart?.fti?.camper?.benum?.length > 0">
    <app-header></app-header>
    <iframe [src]="src | safe" height="100%" width="100%"  allow-same-origin allowtransparency="true">
    </iframe>
    <footer></footer>
</ng-container>